export type CmsContentField = {
  contentKey: string;
  label: string;
  defaultValue: string;
};

export const CMS_CONTENT_FIELDS: CmsContentField[] = [
  {
    contentKey: "home.hero.primary",
    label: "Strona główna: pierwszy opis w nagłówku",
    defaultValue: "Profesjonalne wyposażenie techniczne.",
  },
  {
    contentKey: "home.hero.secondary",
    label: "Strona główna: drugi opis w nagłówku",
    defaultValue: "Obsługujemy firmy i klientów indywidualnych z całego Pomorza.",
  },
  {
    contentKey: "home.assortment.title",
    label: "Strona główna: tytuł sekcji asortymentu",
    defaultValue: "Pełne wyposażenie warsztatu w jednym miejscu",
  },
  {
    contentKey: "home.assortment.description",
    label: "Strona główna: opis sekcji asortymentu",
    defaultValue: "Od elektronarzędzi Milwaukee przez pneumatykę, po łożyska i elementy złączne. Obsługujemy zakłady produkcyjne, firmy budowlane i klientów indywidualnych z województwa zachodniopomorskiego i pomorskiego.",
  },
  {
    contentKey: "offer.hero.description",
    label: "Oferta: opis w nagłówku",
    defaultValue: "9 kategorii produktów. Obsługujemy firmy i klientów indywidualnych z województwa zachodniopomorskiego i pomorskiego. Odbiór osobisty w Sławnie lub dostawa na terenie regionu.",
  },
  {
    contentKey: "contact.hero.description",
    label: "Kontakt: opis w nagłówku",
    defaultValue: "Sklep stacjonarny w Sławnie. Zadzwoń, napisz lub odwiedź nas osobiście",
  },
  { contentKey: "home.highlight.0", label: "Strona główna: opis wyróżnika 24 lata", defaultValue: "Działamy od 2002 roku w regionie zachodniopomorskim i pomorskim." },
  { contentKey: "home.highlight.1", label: "Strona główna: opis wyróżnika 9 kategorii", defaultValue: "Elektronarzędzia, pneumatyka, narzędzia warsztatowe, łożyska i więcej." },
  { contentKey: "home.highlight.2", label: "Strona główna: opis wyróżnika oryginalne produkty", defaultValue: "Wyłącznie oryginalne narzędzia Milwaukee i sprawdzonych producentów." },
  { contentKey: "home.category.0", label: "Strona główna: opis Elektronarzędzi Milwaukee", defaultValue: "Wiertarki, szlifierki, piły, wkrętarki akumulatorowe" },
  { contentKey: "home.category.1", label: "Strona główna: opis Pneumatyki", defaultValue: "Sprężarki, pistolety pneumatyczne, węże" },
  { contentKey: "home.category.2", label: "Strona główna: opis Narzędzi warsztatowych", defaultValue: "Klucze, wkrętaki, narzędzia ręczne" },
  { contentKey: "home.category.3", label: "Strona główna: opis Materiałów ściernych", defaultValue: "Tarcze, papiery ścierne, ściernice" },
  { contentKey: "home.category.4", label: "Strona główna: opis Narzędzi skrawających", defaultValue: "Wiertła, frezy, płytki skrawające" },
  { contentKey: "home.category.5", label: "Strona główna: opis Narzędzi pomiarowych", defaultValue: "Suwmiarki, mikrometry, poziomice, mierniki" },
  { contentKey: "home.category.6", label: "Strona główna: opis Chemii technicznej", defaultValue: "Smary, oleje, kleje, uszczelniacze" },
  { contentKey: "home.category.7", label: "Strona główna: opis Materiałów spawalniczych", defaultValue: "Elektrody, druty, maski i akcesoria" },
  { contentKey: "home.category.8", label: "Strona główna: opis Łożysk i elementów złącznych", defaultValue: "Śruby, nakrętki, łożyska toczne" },
  { contentKey: "offer.category.0", label: "Oferta: opis Elektronarzędzi Milwaukee", defaultValue: "Autoryzowany punkt sprzedaży Milwaukee pełna gama narzędzi systemu M18 i M12 dostępna w stałej sprzedaży." },
  { contentKey: "offer.category.1", label: "Oferta: opis Pneumatyki", defaultValue: "Kompletne wyposażenie do instalacji pneumatycznych dla warsztatów i zakładów produkcyjnych." },
  { contentKey: "offer.category.2", label: "Oferta: opis Narzędzi warsztatowych", defaultValue: "Narzędzia ręczne do codziennej pracy w warsztacie trwałe, precyzyjne, z gwarancją." },
  { contentKey: "offer.category.3", label: "Oferta: opis Materiałów ściernych", defaultValue: "Materiały ścierne do metalu, betonu i drewna szeroki wybór ziarnistości i rozmiarów." },
  { contentKey: "offer.category.4", label: "Oferta: opis Narzędzi skrawających", defaultValue: "Narzędzia skrawające ręczne i maszynowe do obróbki metalu, tworzyw i drewna." },
  { contentKey: "offer.category.5", label: "Oferta: opis Narzędzi pomiarowych", defaultValue: "Precyzyjne narzędzia pomiarowe dla wymagających zastosowań przemysłowych." },
  { contentKey: "offer.category.6", label: "Oferta: opis Chemii technicznej", defaultValue: "Chemia techniczna, w tym produkty z certyfikatem NSF do zastosowań w przemyśle spożywczym." },
  { contentKey: "offer.category.7", label: "Oferta: opis Materiałów i urządzeń spawalniczych", defaultValue: "Kompletne wyposażenie stanowiska spawalniczego dla profesjonalistów." },
  { contentKey: "offer.category.8", label: "Oferta: opis Śrub, nakrętek i łożysk", defaultValue: "Szeroki asortyment elementów złącznych i łożysk dostępne od ręki lub na zamówienie." },
];

export const CMS_MEDIA_SLOTS = [
  { slot: "home-hero", label: "Strona główna: zdjęcie w nagłówku", altText: "Wnętrze sklepu PPHU Imperium" },
  { slot: "offer-hero", label: "Oferta: zdjęcie w nagłówku", altText: "Asortyment PPHU Imperium" },
  { slot: "gallery-1", label: "Galeria: zdjęcie 1", altText: "PPHU Imperium" },
  { slot: "gallery-2", label: "Galeria: zdjęcie 2", altText: "PPHU Imperium" },
  { slot: "gallery-3", label: "Galeria: zdjęcie 3", altText: "PPHU Imperium" },
  { slot: "gallery-4", label: "Galeria: zdjęcie 4", altText: "PPHU Imperium" },
  { slot: "gallery-5", label: "Galeria: zdjęcie 5", altText: "PPHU Imperium" },
  { slot: "gallery-6", label: "Galeria: zdjęcie 6", altText: "PPHU Imperium" },
  { slot: "gallery-7", label: "Galeria: zdjęcie 7", altText: "PPHU Imperium" },
  { slot: "gallery-8", label: "Galeria: zdjęcie 8", altText: "PPHU Imperium" },
  { slot: "gallery-9", label: "Galeria: zdjęcie 9", altText: "PPHU Imperium" },
  { slot: "gallery-10", label: "Galeria: zdjęcie 10", altText: "PPHU Imperium" },
  { slot: "gallery-11", label: "Galeria: zdjęcie 11", altText: "PPHU Imperium" },
  { slot: "gallery-12", label: "Galeria: zdjęcie 12", altText: "PPHU Imperium" },
  { slot: "gallery-13", label: "Galeria: zdjęcie 13", altText: "PPHU Imperium" },
] as const;

export function makeCmsContentMap(records: Array<{ contentKey: string; value: string }>) {
  const values = new Map(records.map(record => [record.contentKey, record.value]));
  return Object.fromEntries(
    CMS_CONTENT_FIELDS.map(field => [field.contentKey, values.get(field.contentKey) || field.defaultValue])
  ) as Record<string, string>;
}
